import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import Cookies from "universal-cookie";
import { func, object, array, string } from "prop-types";

import StaticHeader from "./StaticHeader";
import PopupOverlay from "../../../molecules/PopupOverlay";
import VerticalMenubar from "../VerticalMenubar";

import { setBookmark, setJwtToken, setMember, setMobileFilter, breakingNewsAd } from "../../../helper/actions";
import { getJwt, getUser } from "../../../helper/api";
import { domainSlugFind, checkRender } from "../../../utils/utils";
import { PAGE_TYPES_NOT_ADS, PAGE_TYPE_NOT_HEADER_FOOTER } from "../../../../constants";

import "./uniformHeader.m.css";

const { BroadcastChannel } = require("broadcast-channel");

const UniformHeader = ({
  publisherAttributes,
  navigateToPage,
  member,
  setMember,
  setJwtToken,
  setBookmark,
  setMobileFilter,
  domainSlug,
  breakingNewsAd,
  hamburgerMenu,
  sections,
  pageType,
  currentPath,
}) => {
  if (checkRender(PAGE_TYPE_NOT_HEADER_FOOTER, pageType)) return null;

  const [dot, setDot] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [verifySuccess, setVerifySuccess] = useState(false);
  const [showPopUp, setShowPopup] = useState(true);
  const [message, setMessage] = useState("");
  const [isVerticalMenubar, setVerticalMenuBar] = useState(false);
  const [domainslug, setDomainSlug] = useState(domainSlug);

  const previewEvent = useCallback((event) => {
    if (event && event.data && event.data.story) {
      const story = event.data.story;
      const slug = domainSlugFind(sections, story.sections[0]);
      setDomainSlug(slug);
    }
  });

  useEffect(() => {
    if (!PAGE_TYPES_NOT_ADS.includes(pageType)) {
      window?.googletag?.cmd?.push(function () {
        window?.googletag?.destroySlots();
      });
    }
  }, [currentPath]);

  useEffect(() => {
    global.addEventListener("message", previewEvent);
    return () => global.removeEventListener("message", previewEvent);
  }, [previewEvent]);

  useEffect(() => {
    const channel = new BroadcastChannel("logout-channel");
    channel.onmessage = (msg) => {
      setMember(null);
      setJwtToken(null);
      setBookmark(null);
    };
  });

  useEffect(() => {
    isVerticalMenubar
      ? global.isDesktop
        ? (global.document.body.style.cssText = "overflow: hidden; padding-right: 15px; width: 100%; max-height: 100vh")
        : (global.document.body.style.cssText = "overflow: hidden; padding-right: 0px; width: 100%;")
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [isVerticalMenubar]);

  const cookies = new Cookies();

  const getNotifications = () => {
    fetch(`/feapi/push-engage-notifications?limit=4&offset=0`)
      .then((res) => res.json())
      .then((resp) => {
        setNotifications(resp.notifications);
        if (cookies.get("notifications") && resp.notifications.length > 0) {
          resp.notifications[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
        } else {
          setNotifications(resp.notifications);
          resp.notifications.length > 0 && setDot(true);
        }
      });
  };

  const changePopupView = () => {
    const isHashPresent = global.location.href.substr(0, global.location.href.indexOf("#"));
    const finalRedirectUrl = new URL(isHashPresent);
    navigateToPage(finalRedirectUrl.pathname || "/");
    setShowPopup(false);
  };

  useEffect(() => {
    if (global.location && global.location.hash === "#email-verification") {
      setVerifySuccess(true);
    }

    if (global.location) {
      if (global.location.hash === "#email-verified") {
        setVerifySuccess(true);
        setMessage("Email verified.");
      } else if (global.location.hash === "#token-consumed") {
        setVerifySuccess(true);
        setMessage("The verification link is already used.");
      } else if (global.location.hash === "#invalid-token") {
        setVerifySuccess(true);
        setMessage("The verification link is invalid. Please request for a new link.");
      } else if (global.location.hash === "#internal-error") {
        setVerifySuccess(true);
        setMessage("Something went wrong. Please try again.");
      }
    }
  }, []);

  useEffect(() => {
    getNotifications();
    setVerticalMenuBar(false);
    isVerticalMenubar && setVerticalMenuBar(false);
    const interval = setInterval(() => {
      getNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  const toggleNotifications = () => {
    if (!showNotifications) {
      setDot(false);
    }
    setShowNotifications(!showNotifications);
  };

  const toggleVerticalMenubar = () => {
    setVerticalMenuBar(!isVerticalMenubar);
    breakingNewsAd(!!isVerticalMenubar);
    setMobileFilter(false);

    try {
      const header = document.getElementById("header");
      if (!isVerticalMenubar) {
        header.classList.add("fixed-header");
      } else {
        header.classList.remove("fixed-header");
      }
    } catch (er) {}
  };

  useEffect(() => {
    getUser()
      .then((response) => {
        setMember(response.user);
        const integrationsId = get(publisherAttributes, ["integrations_id"], null);
        if (response.user["verification-status"]) {
          getJwt(integrationsId).then((res) => {
            res.status === 200 && setJwtToken(res.headers.get("x-integration-token"));
          });
        }
      })
      .catch((ex) => {});
  }, []);

  return (
    <div styleName={`base`} className={`${domainslug}-wrapper`}>
      <StaticHeader
        toggleVerticalMenubar={toggleVerticalMenubar}
        isVerticalMenubar={isVerticalMenubar}
        dot={dot}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
        notifications={notifications}
        domainSlug={domainslug}
      />
      {isVerticalMenubar && (
        <VerticalMenubar
          toggleVerticalMenubar={toggleVerticalMenubar}
          hamburgerMenu={hamburgerMenu}
          domainSlug={domainslug}
        />
      )}
      {verifySuccess && showPopUp && member && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          onClickHandler={changePopupView}
          buttonType="continue"
          buttonContent="Continue"
        />
      )}
      {verifySuccess && !member && showPopUp && (
        <PopupOverlay
          lang={publisherAttributes.lang}
          popupMessage={message}
          buttonType="login"
          buttonContent="Continue"
        />
      )}
    </div>
  );
};

UniformHeader.propTypes = {
  currentPath: string,
  publisherAttributes: object,
  navigateToPage: func,
  member: object,
  setMember: func,
  setJwtToken: func,
  setBookmark: func,
  setMobileFilter: func,
  breakingNewsAd: func,
  hamburgerMenu: array,
  domainSlug: string,
  sections: array,
  pageType: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
  member: state.member || null,
  domainSlug: get(state, ["qt", "config", "domainSlug"]),
  hamburgerMenu: get(state, ["qt", "data", "navigationMenu", "menuItems"], []).find(
    (item) => item.title === "hamburger"
  )?.children,
  currentPath: state?.qt?.currentPath ?? "",
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMember: (member) => dispatch(setMember(member)),
  setJwtToken: (token) => dispatch(setJwtToken(token)),
  setBookmark: (obj) => dispatch(setBookmark(obj)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
  breakingNewsAd: (flag) => dispatch(breakingNewsAd(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UniformHeader);
